import { useState } from 'react'
import { TextField, DatePicker, TimePicker } from 'mui-rff'
import { Field } from 'react-final-form'
import { InputAdornment, IconButton, makeStyles } from '@material-ui/core'
import { Visibility, VisibilityOff } from '@material-ui/icons/'
import PropTypes from 'prop-types'
import dynamic from 'next/dynamic'
import Pickr from './colorinput'
import { checkRule } from '../../utils/rules'
import DayjsUtils from '@date-io/dayjs'
import { useClient } from 'components/session/clientSession'

const useStyles = makeStyles(() => ({
  required: {
    color: 'var(--button-color)',
    position: 'absolute',
    top: '0px',
    right: '2px'
  }
}))

export default function TextInput(props) {
  const clientSession = useClient()
  const classes = useStyles()
  const [showPassword, setShowPassword] = useState(false)
  const [showcolor, setShowColor] = useState(false)
  const [randomId, setRandomId] = useState(null)
  const [isNotValid, setIsNotValid] = useState(false)
  const { validationrule, valuechange, required, size, variant, fullWidth } = props
  const childProps = { ...props }
  delete childProps.validationrule
  delete childProps.valuechange
  const type = getInputType(validationrule)
  let shortInput = !(fullWidth === true)
  let out

  if (validationrule === 'Phone Number') {
    const MuiPhoneNumber = dynamic(import('material-ui-phone-number'), { ssr: false })
    out = <Field type={type} {...childProps} component={({ input }) => <MuiPhoneNumber {...input} {...childProps} defaultCountry={clientSession?.client?.DefaultCountryCode ?? 'us'} fullWidth={true} isValid={value => checkRule(validationrule, value)} countryCodeEditable={false} disableAreaCodes />} />
  }

  else if (validationrule === 'Color') {
    const s = size === 'small' ? 40 : 55
    if (!randomId) setRandomId(`id-${Math.random()}`)
    out = <>
      <Pickr valuechange={valuechange} show={showcolor} setshow={setShowColor} randomid={randomId} size={size} />
      <TextField data-color-id={randomId} style={{ width: `calc(100% - ${s}px)` }} {...childProps} fullWidth={false} disabled={true} onClick={() => {
        if (isNotValid) setIsNotValid(false)
        setShowColor(true)
      }} onChange={e => {
        const val = `${e.target.value}`
        if (!checkRule(validationrule, val) || (!val && required)) setIsNotValid(true)
      }} />
    </>
  }

  else if (validationrule === 'Password') {
    const handleMouseDownPassword = (event) => event.preventDefault()
    const handleClickShowPassword = () => setShowPassword(!showPassword)
    out = <TextField error={isNotValid} type={type} {...childProps} onClick={() => { if (isNotValid) setIsNotValid(false) }} InputProps={{
      type: showPassword ? 'text' : 'password',
      endAdornment: <InputAdornment>
        <IconButton
          aria-label="toggle password visibility"
          onClick={handleClickShowPassword}
          onMouseDown={handleMouseDownPassword}
        >
          {showPassword ? <Visibility /> : <VisibilityOff />}
        </IconButton>
      </InputAdornment>,
    }} onBlur={e => {
      if (!`${e.target.value}` && required) setIsNotValid(true)
    }} />
  }

  else if (validationrule === 'Email') {
    out = <TextField type={type} {...childProps} error={isNotValid} onClick={() => { if (isNotValid) setIsNotValid(false) }} onBlur={e => {
      const val = `${e.target.value}`
      if (!checkRule(validationrule, val) || (!val && required)) setIsNotValid(true)
    }} />
  }

  else if (validationrule === 'Date') {
    out = <DatePicker {...childProps} format={'MMMM DD, YYYY'} dateFunsUtils={DayjsUtils} inputVariant={variant} />
  }

  else if (validationrule === 'Time') {
    out = <TimePicker {...childProps} dateFunsUtils={DayjsUtils} inputVariant={variant} />
  }

  else {
    out = <TextField type={type} {...childProps} error={isNotValid} onClick={() => { if (isNotValid) setIsNotValid(false) }} onBlur={e => {
      if (!`${e.target.value}` && required) setIsNotValid(true)
    }} />
  }

  if (shortInput) {
    return out
  } else {
    return <div style={{ position: 'relative' }}>
      {out}
      {required ? <span className={classes.required}>*</span> : ''}
    </div>
  }
}

TextInput.propTypes = {
  validationrule: PropTypes.string,
  valuechange: PropTypes.func,
  required: PropTypes.bool,
  size: PropTypes.string,
  variant: PropTypes.string,
  fullWidth: PropTypes.bool
}

export function getInputType(rule) {
  if (rule === 'Any') return 'text'
  else if (rule === 'Number') return 'number'
  else if (rule === 'Phone Number') return 'tel'
  else if (rule === 'Email') return 'email'
  else if (rule === 'Color' && !(/MSIE \d|Trident.*rv:/.test(navigator.userAgent))) return 'color'
  else if (rule === 'Password') return 'password'
  else return 'text'
}